"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxGridContainer = void 0;
const styled_1 = __importDefault(require("../../../styles/styled"));
const layout_1 = require("../../layout");
exports.CheckboxGridContainer = (0, styled_1.default)(layout_1.Grid)(({ itemsPerRow = 1 }) => ({
    gridTemplateColumns: `repeat(${itemsPerRow}, 1fr)`,
    columnGap: '1rem',
    // These aren't really needed but it makes a nicer view if
    // if you have the console or inspector open
    '@media (max-width: 1124px)': {
        gridTemplateColumns: `repeat(${Math.min(itemsPerRow, 2)}, 1fr)`,
    },
    '@media (max-width: 600px)': {
        gridTemplateColumns: 'repeat(1, 1fr)',
    },
}));
exports.CheckboxGridContainer.defaultProps = {
    width: '45vw',
};
//# sourceMappingURL=checkbox_grid_container.js.map